module.exports = {
	appName:'财富海西综合管理平台',
	qqMapKey:'ETLBZ-SQYCT-57IX6-VAXZ2-IRTAT-RSFTX',
	imgSizeLimit:10*1024*1024,
	fileSizeLimit:300*1024*1024,
	imgAccepts:['jpg', 'jpeg', 'gif', 'png', 'bmp', 'svg', 'webp', 'heic', 'heif'],
	videoSizeLimit:1024*1024*1024,
	videoAccepts:['mp4', 'wmv','m3u8'],
	whetherOptions:{0:'否',1:'是'},
	statusOptions:{0:'停用',1:'启用'},
	sexOptions:{0:'保密',1:'男',2:'女'},

	docx:{
		types:{
		}
	},

	tableIndexMethod: function(i){
		return i+1;
	},

	resetAndGetFilePreviewPath: function(arr, host){
		let prearr = [],path = null;
		if(arr){
			let path = null;
			for(var j=0,jl=arr.length; j<jl; j++){
				if(arr[j]['file_url'].indexOf(host) == -1 && arr[j]['file_url'].toLowerCase().indexOf("http")==-1){
					path = host + '/' + arr[j]['file_url'];
					arr[j]['file_url'] = path;
				}else{
					path = arr[j]['file_url'];
				}
				if(!this.chkVideoFile(path)){
					prearr.push(path);
				}
			}
		}
		return [arr,prearr];
	},
	resetUrl(url, host, def){
		if(url){
			if(url.indexOf(host) == -1 && url.toLowerCase().indexOf("http")==-1){
				return host + '/' + url;
			}else{
				return url;
			}
		}
		return def;
	},
	num2chinese: function(num){
		var arr1 = ['零','一','二','三','四','五','六','七','八','九'];
		var arr2 = ['','十','百','千','万','十','百','千','亿','十','百','千','万','十','百','千','亿'];
		if(!num || isNaN(num)) return arr1[0];
		var eng = num.toString().split('');
		var rst = '';
		for(var i=0,il=eng.length; i<il; i++){
			var desi = il-1-i;
			rst = arr2[i] + rst;
			var ind = eng[desi];
			rst = arr1[ind]+rst;
		}
		rst = rst.replace(/零(千|百|十)/g,'零').replace(/十零/g,'十');
		rst = rst.replace(/零+/g,'零');
		rst = rst.replace(/零亿/g,'亿').replace(/零万/g,'万');
		rst = rst.replace(/亿万/g,'亿');
		rst = rst.replace(/零+$/g,'');
		rst = rst.replace(/^一十/g,'十');
		return rst;
	},
	chkUploadFiles:function(file, fileList){
		const splitName = file.name.split(".");
		const fileName = splitName[splitName.length-1].toLowerCase();
		const chkImg = this.imgAccepts.indexOf(fileName) === -1;
		const chkVideo = this.videoAccepts.indexOf(fileName) === -1;
		if (chkImg && chkVideo) {
			return "请上传文件格式为jpeg/gif/png/mp4/wmv";
		}
		if (!chkImg && file.size > this.imgSizeLimit) {
			return "上传文件不能超过"+(this.imgSizeLimit/1024)+"Kb！";
		}
		if (!chkVideo && file.size > this.videoSizeLimit) {
			return "上传文件不能超过"+(this.videoSizeLimit/1024/1024)+"M！";
		}
		return "";
	},
	chkImageFile(url){
		let filename = url.split(".");
		return this.imgAccepts.indexOf(filename[filename.length-1].toLowerCase())>-1;               
	},
	chkVideoFile(url){
		let filename = url.split(".");
		return this.videoAccepts.indexOf(filename[filename.length-1].toLowerCase())>-1;               
	},
		
	compWorkorderAttach(data, attach, host){
		if(!attach) return data;
		let preimgs = [];
		let files = null;
		let tmp = null;
		let inpreimgs = null;
		for(var k in attach['keys']){
			if(data[k]){
				if(attach['keys'][k]['multi'] == true){
					files = {'imgs':[],'files':[]};
					inpreimgs = [];
					for(var f=0,fl=data[k].length; f<fl; f++){
						tmp = data[k][f];
						tmp['url'] = this.resetUrl(tmp['file_url'],host);
						if(this.chkImageFile(tmp['file_url'])){
							inpreimgs.push(tmp['url']);
							if(attach['preview_all'] == true){
								preimgs.push(tmp['url']);
							}
							files['imgs'].push(tmp);
						}else{
							files['files'].push(tmp);
						}	
					}
					if(inpreimgs.length > 0){
						files['previews'] = inpreimgs;
					}
					data[k] = files;
				}else{
					files = {'imgs':[],'files':[]};
					tmp = data[k];
					tmp['url'] = this.resetUrl(tmp['file_url'],host);
					if(this.chkImageFile(tmp['file_url'])){
						if(attach['preview_all'] == true){
							preimgs.push(tmp['url']);
						}
						files['imgs'].push(tmp);
					}else{
						files['files'].push(tmp);
					}
					data[k] = files;
				}
			}
		}
		if(attach['preview_all'] == true && preimgs.length > 0){
			for(var k in attach['keys']){
				if(data[k]){
					data[k]['previews'] = preimgs;
				}
			}
		}
		return data;
	},
		
	computeWorkorderTotalSettle(dataInfo){
		let total = Number(0);
		if(dataInfo.amount){
			total = parseFloat(dataInfo.amount);
			if(dataInfo.supply && dataInfo.supply.length){
				for(var i=0,il=dataInfo.supply.length; i<il; i++){
					if(dataInfo.supply[i]['amount'] && dataInfo.supply[i]['method']){
						total = parseFloat(total)+parseInt(dataInfo.supply[i]['method'])*parseFloat(dataInfo.supply[i]['amount']);
					}
				}
			}
		}
		return total.toFixed(2);
	},

	containsNonChinese(str) {
		var reg = new RegExp("[\\u4E00-\\u9FA5]+$","g");
		return !reg.test(str);
	},
		
	getImgUrl(src, pic) {
		const RegEx = /src=(?:\\"|")?([^"\\\s>]+)(?:\\"|")?/;// /(?<=(img src="))[^"]*?(?=")/g
		if(src && src.match(RegEx) && src.match(RegEx).length > 0) {
			return src.match(RegEx)[1]
		}
		return pic;
	},
}


// WEBPACK FOOTER //
// ./src/common/constants.js